const CalenderMonth = (props) => {

    return (
        <div className="calender_year text-left mt-4">
            <h4 className="d-inline"> Month  </h4> <span className="clear_filter" onClick={()=>props.monthFilter()}> Clear Filter</span>
            <div className="row text-center pr-2">
                {props.month.map(e => <Month key={e.id} month={e} monthFilter={props.monthFilter} FilteredData={props.FilteredData}/> )}
                
            </div>
        </div>
    )
}

function Month(props) {
    return(
        <div className="calender_year__col p-1 col col-3"> <div  className={props.FilteredData.filteredMonth==props.month.id ? "calender_year__block p-2 filter_active" : "calender_year__block p-2"}  onClick={()=>props.monthFilter(props.month.id)}> {props.month.name} </div> </div>
    )
}
export default CalenderMonth;